




































































































import { Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';

import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';

import PlateInput from '../../../components/plate-input/index.vue';
// 接口
import Utils from '@root/utils/common';
import { visitStatusMap } from '@/types/visitor-car-management';
import moment from 'moment';
import { queryAppointmentRecord } from '@/api/visitor-car-management';
import NewBooking from './components/new-booking.vue';
import DetailBooking from './components/detail-booking.vue';
import AppointmentBooking from './components/appointment-booking.vue';
import DistributionTrack from '@/components/distribution-track/index.vue';
@Component({
  name: 'AppointmentRecord',
  components: {
    ParkingLotSearch,
    PlateInput,
    NewBooking,
    DetailBooking,
    AppointmentBooking,
    DistributionTrack
  }
})
export default class AppointmentRecord extends Mixins(TableMixin, TableWidthMixin) {
  private tableLoading = false;
  private plateInputModel = false;
  private appointmentId: string = '';
  private visitStatusList = Utils.toLabelVal(visitStatusMap);
  private filterParam: any = {
    parkIds: [],
    plateHead: '',
    plateTail: '',
    ownerPhone: '',
    ownerRoomNo: '',
    visitStatus: '',
    userValue: '',
    startTime: moment().format('YYYY-MM-DD') + ' 00:00:00',
    endTime: moment().format('YYYY-MM-DD') + ' 23:59:59',
    userType: '01'
  };
  showAdd: boolean = false;
  showDetail: boolean = false;
  showAppointmentDeatil: boolean = false;
  dictIssuedOpinionMap = this.$store.state.dictionaries.allDictionaries.send_status;
  created() {
    this.fetchTableData();
  }
  search() {
    this.current = 1;
    this.fetchTableData();
  }
  clear({ defaultParkIdList }) {
    this.plateInputModel = true;
    this.filterParam = {
      parkIds: defaultParkIdList,
      plateHead: '',
      plateTail: '',
      ownerPhone: '',
      ownerRoomNo: '',
      userValue: '',
      visitStatus: '',
      startTime: moment().format('YYYY-MM-DD') + ' 00:00:00',
      endTime: moment().format('YYYY-MM-DD') + ' 23:59:59',
      userType: '01'
    };
    this.search();
  }

  private moment = moment;
  // 车牌变化
  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }

  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const { parkIds, plateHead, plateTail, startTime, endTime, userValue, visitStatus, userType } = this.filterParam;
      if (plateTail && plateHead === '') {
        return this.$message.error('请先选择省份再进行查询');
      }
      const { data } = await queryAppointmentRecord({
        parkIds: '' + parkIds,
        plateHead,
        plateTail,
        startTime,
        endTime,
        ownerPhone: userType === '01' ? userValue : '',
        ownerRoomNo: userType === '01' ? '' : userValue,
        visitStatus,
        userType,
        currPage: this.current,
        pageSize: this.pageSize
      });
      if (data) {
        const { totalNum = 0, datas = [] } = data;
        this.total = Number(totalNum);
        if (datas.length > 0) {
          this.tableData = Object.freeze(datas);
        } else {
          this.tableData = [];
        }
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }
  get defaultTime() {
    if (this.filterParam.startTime && this.filterParam.endTime) {
      return [
        this.moment(this.filterParam.startTime, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.endTime, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.startTime) {
      return [this.moment(this.filterParam.startTime, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }
  // 支付时间变化
  private onEnterTimeChange(date: any, dateString: any) {
    const [startTime, endTime] = dateString;
    this.filterParam.startTime = startTime;
    this.filterParam.endTime = endTime;
  }

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }
  private tableData = [];
  get tableColums() {
    return [
      {
        title: '序号',
        width: 70,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '访客车牌号',
        dataIndex: 'plateNo',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '访客姓名',
        dataIndex: 'visitor',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '访客电话',
        dataIndex: 'visitorPhone',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '预约来访时段',
        dataIndex: 'visitTime',
        width: 340
      },
      {
        title: '预约状态',
        dataIndex: 'visitStatus'
      },
      {
        title: '来访事由',
        dataIndex: 'visitorTypeName'
      },
      {
        title: '业主姓名',
        dataIndex: 'ownerName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '业主房号',
        dataIndex: 'ownerRoomNo',
        scopedSlots: { customRender: 'text-ellipse' },
        width: 200
      },
      {
        title: '业主电话',
        dataIndex: 'ownerPhone',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '操作时间',
        dataIndex: 'createTime',
        width: 200
      },
      {
        title: '下发状态',
        dataIndex: 'issuedStatusEnum',
        scopedSlots: { customRender: 'issuedStatusEnum' }
      },
      {
        title: '操作人',
        dataIndex: 'userName'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
        fixed: 'right',
        width: 140
      }
    ];
  }

  private toNewBooking() {
    this.showAdd = true;
  }

  private showCorrection(appointmentId: string) {
    this.appointmentId = appointmentId;
    this.showDetail = true;
  }

  private showAppointment(appointmentId: string) {
    this.appointmentId = appointmentId;
    this.showAppointmentDeatil = true;
  }
  trendData: any = {};
  trendVisible: boolean = false;
  //显示下发轨迹
  showTrend(record: any) {
    this.trendData = record;
    this.trendData.businessKey = record.appointmentId;
    this.trendData.businessType = '04';
    this.trendData.sendStatus = record.issuedStatusEnum;
    this.trendVisible = true;
  }
  //关闭弹框
  closeIt() {
    this.trendVisible = false;
  }
  //重新下发
  redistribute() {
    this.closeIt();
    this.fetchTableData();
  }
}
